import React from 'react'
import './PaygeListItem.css'
import { Visibility, ArrowDownward, OpenInNew, MoreHoriz, Delete } from '@material-ui/icons'
import { themeColors } from '../../constants'

const imgurl = "https://images.unsplash.com/photo-1531934788018-04c3cd417b80?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjEyODM3M30"

export default class PaygeListItem extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isMoreOptionsOpen: false,
      justCopied: false,
    }
  }

  // copying to clipboard
  copyLinkToClipboard = (text) => {
    let context = this
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(text).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.setState({justCopied: true})
          setTimeout(() => context.setState({justCopied: false, isMoreOptionsOpen: false}), 500)
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }

  render() {
    const { isMoreOptionsOpen, justCopied } = this.state
    let { payge, currentType, onDelete } = this.props

    const paygeDetails = payge.paygeDetails
    let name = currentType === 'pro' ? paygeDetails.landing.title : paygeDetails.name
    let description = currentType === 'pro' ? paygeDetails.landing.description : paygeDetails.description
    let paygeUrl = payge.paygeUrl
    let views = payge.viewCount
    let downloads = payge.downloadCount
    let files = payge.files
    let backgroundUrl = currentType !== 'collection' ? payge.backgroundImage.urls.small : false
    let currentThemeColor = themeColors[0]
    themeColors.map(color => {
      if (color.name == (currentType === 'pro' ? paygeDetails.landing.themeColor : paygeDetails.themeColor)) { 
        currentThemeColor = color 
      }
    })

    if (name.length > 43) {
      name = name.substring(0, 40) + '...'
    }
    if (description.length > 65) {
      description = description.substring(0, 63) + '...'
    }

    return (
      <li className="payge-item">
        { 
          currentType === 'collection' ? (
            <div 
              className="collection-top"
              style={{background: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]}, 0.03)`}}>
              <span 
                className="count"
                style={{
                  background: `linear-gradient(125deg, 
                    rgba(${currentThemeColor.gradient[0][0]},${currentThemeColor.gradient[0][1]}, ${currentThemeColor.gradient[0][2]}, ${currentThemeColor.gradient[0][3]}) 0%, 
                    rgba(${currentThemeColor.gradient[1][0]},${currentThemeColor.gradient[1][1]}, ${currentThemeColor.gradient[1][2]}, ${currentThemeColor.gradient[1][3]}) 25%, 
                    rgba(${currentThemeColor.gradient[2][0]},${currentThemeColor.gradient[2][1]}, ${currentThemeColor.gradient[2][2]}, ${currentThemeColor.gradient[2][3]}) 100%)`
                }}>
                {files.length}
              </span>
              <span className="simple-text">files</span>
            </div>
          ) : (
            <img src={backgroundUrl} className="item-bg" />
          )
        }
        <div className="text-container">
          <div className="info-container">
            <span className="name">{name}</span>
            <span className="description">{description}</span>
            <span className="link" onClick={()=>window.open(paygeUrl, '_blank')}>
              {paygeUrl.replace('https://', '')} <OpenInNew className="icon" />
            </span>
          </div>
          <div style={{display:'flex', flexDirection: 'row'}}>
            <ul className="analytics-list">
              <li>
                <Visibility className="icon" />
                <span className="value">{views}</span>
              </li>
              <li>
                <ArrowDownward className="icon" />
                <span className="value">{downloads}</span>
              </li>
            </ul>
            <MoreHoriz className="more-icon" onClick={()=>this.setState({isMoreOptionsOpen: !isMoreOptionsOpen})} />
            {
              isMoreOptionsOpen ? (
                <ul className="more-container">
                  <li onClick={()=>this.copyLinkToClipboard(paygeUrl)}>
                    <span>{ justCopied ? 'Copied' : 'Copy Link'}</span>
                  </li>
                  <li className="delete" onClick={()=>onDelete(payge, currentType)}>
                    <span>Delete</span>
                  </li>
                </ul>
              ) : false
            }
          </div>
        </div>
      </li>
    )
  }

}